import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../../store';
import { deleteMethod, get, post, put } from '../../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  balance: [],
  loggedInLeave: [],
  selectedLeave: [],
  currentLeave: [],
  documentTypes: [],
  documents: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'Leave',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET LeaveManagement
    getLeaveSuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET LeaveManagement
    getLeaveBalanceSuccess(state, action) {
      state.balance = action.payload.data;
    },
    // GET LeaveManagement
    updateCurrentLoggedInLeaveData(state, action) {
      state.loggedInLeave = action.payload;
    },

    // GET LeaveManagement
    getCurrentLeaveSuccess(state, action) {
      state.currentLeave = action.payload.data;
      state.documentTypes = action.payload.documentTypes;
      state.documents = action.payload.documents;
    },

    // GET LeaveManagement
    getSpecificLeaveDataSuccess(state, action) {
      state.selectedLeave = action.payload.data;
      state.documentTypes = action.payload.documentTypes;
      state.documents = action.payload.documents;
    },

    addOrUpdateLeaves(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getLeaveBalance(locationId) {
  return async () => {
    try {
      const response = await get(`leaveBalance?locationId=${locationId}`);
      if (response.status) {
        dispatch(slice.actions.getLeaveBalanceSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeave() {
  return async () => {
    try {
      const response = await get(`Leave`);
      if (response.status) {
        dispatch(slice.actions.getLeaveSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeaveById(userId) {
  return async () => {
    try {
      const response = await get(`leaveById?userId=${userId}`);
      if (response.status) {
        dispatch(slice.actions.getLeaveSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addLeave(body) {
  return async () => {
    try {
      const response = await post(`Leave`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateLeaves(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function LeaveUserConfirmation(body) {
  return async () => {
    try {
      const response = await put(`LeaveUserConfirmation`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateLeaves(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function LeaveHRConfirmation(body) {
  return async () => {
    try {
      const response = await put(`LeaveHRConfirmation`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateLeaves(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateLeave(body) {
  return async () => {
    try {
      const response = await put(`Leave`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateLeaves(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteLeave(body) {
  return async () => {
    try {
      const response = await deleteMethod(`Leave`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateLeaves(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
